import { ISquareBannerProps, SquareBanner } from '~/src/features/internetV2/components/banners';
import Carousel from '~/src/features/internetV2/components/Carousel';
import DoubleColumnContainer from '~/src/features/internetV2/components/DoubleColumnContainer';

type TKeyedStaticBannerProps = ISquareBannerProps & {
    key: string,
}

interface IDoubleColumnBannersContainerProps {
    staticBanner: ISquareBannerProps,
    carouselBanners: TKeyedStaticBannerProps[],
}

export const DoubleColumnBannersContainer = ({
    staticBanner,
    carouselBanners,
}: IDoubleColumnBannersContainerProps): JSX.Element => {
    return (
        <DoubleColumnContainer>
            <SquareBanner {...staticBanner} />
            <Carousel>
                {carouselBanners.map(SquareBanner)}
            </Carousel>
        </DoubleColumnContainer>
    );
};
